import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CultureSection = () => {
  const cultureHighlights = [
  {
    title: "Collaborative Environment",
    description: "Open communication, knowledge sharing, and cross-functional collaboration drive our daily operations",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_171170bd3-1764687877901.png",
    imageAlt: "Diverse team of professionals collaborating around modern conference table with laptops and documents in bright office with large windows",
    icon: "Users"
  },
  {
    title: "Continuous Learning",
    description: "Regular training sessions, conference attendance, and dedicated learning time keep our skills sharp",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1044906df-1764671295890.png",
    imageAlt: "Professional workshop setting with instructor presenting to engaged audience in modern training room with projection screen and comfortable seating",
    icon: "BookOpen"
  },
  {
    title: "Work-Life Balance",
    description: "Flexible schedules, remote work options, and wellness programs support our team's well-being",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1141f1d15-1764753589188.png",
    imageAlt: "Relaxed office lounge area with comfortable seating, plants, and natural lighting where team members take breaks and socialize",
    icon: "Heart"
  },
  {
    title: "Innovation Time",
    description: "Dedicated hours for experimentation, side projects, and exploring new technologies fuel creativity",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_162ba5502-1766514925358.png",
    imageAlt: "Creative workspace with whiteboards covered in diagrams and sticky notes, team members brainstorming innovative solutions in modern office",
    icon: "Lightbulb"
  }];


  const perks = [
  { icon: "Home", title: "Remote Work", description: "Flexible location options" },
  { icon: "GraduationCap", title: "Learning Budget", description: "$3,000 annual education fund" },
  { icon: "Heart", title: "Health Coverage", description: "Comprehensive medical benefits" },
  { icon: "Plane", title: "Unlimited PTO", description: "Trust-based time off policy" },
  { icon: "Coffee", title: "Team Events", description: "Regular social gatherings" },
  { icon: "Laptop", title: "Latest Tech", description: "Premium equipment provided" }];


  return (
    <section className="py-16 md:py-24 lg:py-32 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full mb-4 md:mb-6">
            <Icon name="Sparkles" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium font-body text-primary">Our Culture</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-4 md:mb-6">
            Where Talent Thrives
          </h2>
          
          <p className="text-base md:text-lg text-muted-foreground font-body max-w-3xl mx-auto">
            We've built a culture that attracts exceptional talent and nurtures long-term growth. Our team isn't just skilled—they're passionate, collaborative, and committed to excellence.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16 md:mb-24">
          {cultureHighlights?.map((highlight, index) =>
          <div
            key={index}
            className="bg-card rounded-xl shadow-md border border-border overflow-hidden hover:shadow-xl transition-all duration-300 group">

              <div className="aspect-[16/9] overflow-hidden">
                <Image
                src={highlight?.image}
                alt={highlight?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />

              </div>
              
              <div className="p-6 md:p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name={highlight?.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg md:text-xl font-semibold font-headline text-foreground">
                    {highlight?.title}
                  </h3>
                </div>
                
                <p className="text-sm md:text-base text-muted-foreground font-body leading-relaxed">
                  {highlight?.description}
                </p>
              </div>
            </div>
          )}
        </div>
        
        {/* <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl p-6 md:p-8 lg:p-10 border border-border">
          <h3 className="text-xl md:text-2xl font-semibold font-headline text-foreground mb-8 md:mb-10 text-center">
            Team Benefits & Perks
          </h3>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {perks?.map((perk, index) =>
            <div
              key={index}
              className="flex items-start space-x-4 bg-card p-4 md:p-6 rounded-xl shadow-sm border border-border">

                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={perk?.icon} size={24} color="var(--color-primary)" />
                </div>
                
                <div>
                  <h4 className="text-base md:text-lg font-semibold font-headline text-foreground mb-1">
                    {perk?.title}
                  </h4>
                  <p className="text-sm text-muted-foreground font-body">
                    {perk?.description}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div> */}
        
        {/* <div className="mt-12 md:mt-16 text-center">
          <div className="bg-card p-6 md:p-8 rounded-xl shadow-md border border-border inline-block">
            <div className="flex items-center justify-center space-x-4 mb-4">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="TrendingUp" size={32} color="var(--color-primary)" />
              </div>
              <div className="text-left">
                <p className="text-3xl md:text-4xl font-bold font-headline text-foreground">4.8/5</p>
                <p className="text-sm md:text-base text-muted-foreground font-body">Employee Satisfaction</p>
              </div>
            </div>
            <p className="text-sm md:text-base text-muted-foreground font-body max-w-md">
              Based on anonymous internal surveys conducted quarterly
            </p>
          </div>
        </div> */}
      </div>
    </section>);

};

export default CultureSection;